<template>
  <div class="static-swiper">
    <img class="wrapper-background" :src="data.background">
    <div class="swiper-wrapper">
      <swiper :options="swiperOptions">
        <swiper-slide v-for="(item, index) in data.swiper" :key="index">
          <SliderItem :swiperItem="item"/>
        </swiper-slide>
      </swiper>
      <div class="pagination">
        <span
          v-for="(item, index) in data.swiper"
          :key="index"
          :class="{
          'pagination-item': true,
          'pagination-item-active': index === currentPagination,
        }"
        ></span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator';

import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';

import SliderItem from './SwiperItem.vue';

export interface ISwiperData {
  background: string;
  swiper: {
    gif: string;
    background: string;
    avatar: string;
    username: string;
    gender_icon: string;
    user_desc: string;
    comment: string;
    gif_name: string;
    gif_desc: string;
  }[];
}

@Component({
  components: {
    Swiper,
    SwiperSlide,
    SliderItem,
  },
})
export default class StaticSwiper extends Vue {
  @Prop(Object) data!: ISwiperData;
  currentPagination = 0;
  swiperOptions = {
    on: {
      slideChange: this.handleSlideChange,
    },
    slidesPerView: 'auto',
    spaceBetween: -40,
    centeredSlides: true,
  };
  handleSlideChange(sliderItem: any) {
    this.currentPagination = sliderItem.realIndex;
  }
}
</script>

<style lang="scss" scoped>
.static-swiper {
  position: relative;
  width: 100%;
  .wrapper-background {
    width: 100%;
  }
  .swiper-container {
    position: absolute;
    top: 700px;
    width: 100%;
  }
  .swiper-wrapper {
    position: absolute;
    top: 870px;
    width: 100%;
  }
}
.swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.slider-content-item {
  width: 640px;
}
.pagination {
  position: absolute;
  top: 1480px;
  width: 100%;
  text-align: center;
  .pagination-item {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin: 0px 9px;
    background: rgba(255, 255, 255, 24%);
    border-radius: 6px;
  }
  .pagination-item-active {
    background: #fff;
  }
}
</style>
